// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var ReactIO = require("./ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var TypeUtils = require("./types/TypeUtils.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var Relude_List_Specializations = require("relude/src/list/Relude_List_Specializations.bs.js");

function graphQL(param_0) {
  return {
          TAG: /* GraphQL */0,
          _0: param_0
        };
}

function known(param_0) {
  return {
          TAG: /* Known */1,
          _0: param_0
        };
}

function jsExn(param_0) {
  return {
          TAG: /* JsExn */2,
          _0: param_0
        };
}

function dispatchErrorToString(f, error) {
  if (typeof error === "number") {
    if (error === /* Unauthorized */0) {
      return "Error occured. (Unauthorized)";
    } else {
      return "Error occured. (Void)";
    }
  }
  switch (error.TAG | 0) {
    case /* GraphQL */0 :
        return "Error occured. (GraphQL: " + (error._0.message + ")");
    case /* Known */1 :
        return "Error occured." + Curry._1(f, error._0);
    case /* JsExn */2 :
        return "Error occured. (Js Exception)";
    
  }
}

function summonAsyncStoreVoidError(f) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (param) {
          return /* Void */1;
        }));
  var partial_arg$1 = Curry._1(Relude_IO.mapError, f);
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                  return Relude_IO.map(Relude_AsyncResult.fromAsyncData, param);
                }), param);
  };
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, (function (param) {
                  return Relude_IO.catchError((function (param) {
                                return Relude_Globals.$great$great(Relude_AsyncResult.completeError, Relude_IO.pure, param);
                              }), param);
                }), param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$3, partial_arg, param);
  };
}

function AsyncResultWithDispatchError(E) {
  return Relude_AsyncResult.WithError({});
}

function IOWithDispatchError(E) {
  return Relude_IO.WithError({});
}

function update(param_0) {
  return {
          TAG: /* Update */0,
          _0: param_0
        };
}

function sideEffects(param_0) {
  return {
          TAG: /* SideEffects */1,
          _0: param_0
        };
}

function updateWithSideEffects(param_0, param_1) {
  return {
          TAG: /* UpdateWithSideEffects */2,
          _0: param_0,
          _1: param_1
        };
}

function continuation(param_0, param_1, param_2) {
  return {
          TAG: /* Continuation */3,
          _0: param_0,
          _1: param_1,
          _2: param_2
        };
}

function make(initialState, reducer) {
  var state = {
    contents: initialState
  };
  var listeners = {
    contents: /* [] */0
  };
  var updateStateAndNotifyListeners = function (nextState) {
    if (nextState === state.contents) {
      return Relude_IO.pure(undefined);
    } else {
      state.contents = nextState;
      return Curry._2(Relude_IO.mapError, (function (param) {
                    return /* Void */1;
                  }), Relude_IO.map(TypeUtils.ensureList, Relude_List_Specializations.IO.sequence(listeners.contents)));
    }
  };
  var getState = function (param) {
    return state.contents;
  };
  var processActionResult = function (dispatch, nextState) {
    if (typeof nextState === "number") {
      return Relude_IO.pure(undefined);
    }
    switch (nextState.TAG | 0) {
      case /* Update */0 :
          return updateStateAndNotifyListeners(nextState._0);
      case /* SideEffects */1 :
          return Curry._2(nextState._0, state.contents, dispatch);
      case /* UpdateWithSideEffects */2 :
          var fn = nextState._1;
          return Relude_IO.flatMap((function (param) {
                        return Curry._2(fn, state.contents, dispatch);
                      }), updateStateAndNotifyListeners(nextState._0));
      case /* Continuation */3 :
          var nextActionResult = nextState._2;
          var io = nextState._1;
          return Relude_IO.flatMap((function (param) {
                        return Relude_Globals.$great$great(nextActionResult, (function (param) {
                                      return processActionResult(dispatch, param);
                                    }), param);
                      }), Relude_IO.flatMap((function (param) {
                            return Curry._2(io, state.contents, dispatch);
                          }), updateStateAndNotifyListeners(Curry._1(nextState._0, state.contents))));
      
    }
  };
  var dispatch = function (action) {
    return Relude_IO.suspendIO(function (param) {
                return processActionResult(dispatch, Curry._2(reducer, state.contents, action));
              });
  };
  return {
          getState: getState,
          dispatch: dispatch,
          unsubscribe: (function (listener) {
              return Relude_IO.suspend(function (param) {
                          listeners.contents = Relude_List.keep((function (param) {
                                  return listener !== param;
                                }), listeners.contents);
                          
                        });
            }),
          subscribe: (function (listener) {
              return Relude_IO.suspend(function (param) {
                          listeners.contents = {
                            hd: listener,
                            tl: listeners.contents
                          };
                          
                        });
            })
        };
}

function useStore(initialState, reducer) {
  var match = ReactIO.useMappableState(function (param) {
        var store = make(initialState, reducer);
        return [
                Curry._1(store.getState, undefined),
                store
              ];
      });
  var setState = match[1];
  var match$1 = match[0];
  var match$2 = match$1[1];
  var subscribe = match$2.subscribe;
  var unsubscribe = match$2.unsubscribe;
  var setState$1 = ReactIO.useMemo0(function (param) {
        return Curry._1(setState, (function (param) {
                      var store = param[1];
                      return [
                              Curry._1(store.getState, undefined),
                              store
                            ];
                    }));
      });
  ReactIO.useEffect1((function (param) {
          return Relude_Result.fold(Relude_IO.pure, unsubscribe, param);
        }), undefined, (function (setState) {
          return Relude_IO.map((function (param) {
                        return setState;
                      }), Curry._1(subscribe, setState));
        }), setState$1);
  return [
          match$1[0],
          match$2.dispatch
        ];
}

function Make(S) {
  var match = make(S.initialState, S.reducer);
  var subscribe = match.subscribe;
  var unsubscribe = match.unsubscribe;
  var dispatch = match.dispatch;
  var getState = match.getState;
  var useState = function (mapStateToProps) {
    var match = ReactIO.useState(function (param) {
          return Relude_Globals.$great$great(getState, mapStateToProps, param);
        });
    var setStateProps = ReactIO.useMemo2((function (mapStateToProps, setStateProps) {
            return Relude_IO.flatMap(setStateProps, Relude_IO.suspend(function (param) {
                            return Relude_Globals.$great$great(getState, mapStateToProps, param);
                          }));
          }), [
          mapStateToProps,
          match[1]
        ]);
    ReactIO.useEffect1((function (param) {
            return Relude_Result.fold(Relude_IO.pure, unsubscribe, param);
          }), undefined, (function (setStateProps) {
            return Relude_IO.map((function (param) {
                          return setStateProps;
                        }), Curry._1(subscribe, setStateProps));
          }), setStateProps);
    return match[0];
  };
  var useDispatch = function (mapDispatchToProps) {
    return ReactIO.useMemo2((function (prim, prim$1) {
                  return Curry._1(prim$1, prim);
                }), [
                dispatch,
                mapDispatchToProps
              ]);
  };
  var Store$Make$Provider = function (Props) {
    var mapStateToProps = Props.mapStateToProps;
    var mapDispatchToProps = Props.mapDispatchToProps;
    var children = Props.children;
    var stateProps = useState(mapStateToProps);
    var mapDispatchToProps$1 = useDispatch(mapDispatchToProps);
    var dispatchProps = ReactIO.useMemo2((function (prim, prim$1) {
            return Curry._1(prim$1, prim);
          }), [
          stateProps,
          mapDispatchToProps$1
        ]);
    return ReactIO.useMemo3((function (children, stateProps, dispatchProps) {
                  return Curry._2(children, stateProps, dispatchProps);
                }), [
                children,
                stateProps,
                dispatchProps
              ]);
  };
  var Provider = {
    make: Store$Make$Provider
  };
  return {
          getState: getState,
          dispatch: dispatch,
          unsubscribe: unsubscribe,
          subscribe: subscribe,
          useState: useState,
          useDispatch: useDispatch,
          Provider: Provider
        };
}

var unauthorized = /* Unauthorized */0;

var $$void = /* Void */1;

var noUpdate = /* NoUpdate */0;

exports.graphQL = graphQL;
exports.unauthorized = unauthorized;
exports.known = known;
exports.jsExn = jsExn;
exports.$$void = $$void;
exports.dispatchErrorToString = dispatchErrorToString;
exports.summonAsyncStoreVoidError = summonAsyncStoreVoidError;
exports.AsyncResultWithDispatchError = AsyncResultWithDispatchError;
exports.IOWithDispatchError = IOWithDispatchError;
exports.noUpdate = noUpdate;
exports.update = update;
exports.sideEffects = sideEffects;
exports.updateWithSideEffects = updateWithSideEffects;
exports.continuation = continuation;
exports.make = make;
exports.useStore = useStore;
exports.Make = Make;
/* ReactIO Not a pure module */
